/**
 * @param {number} tagId
 * @param {String} type
 * @return {['unknown'] | ['tag', number, String]}
 */
export const tagFocusPath = (tagId, type) => {
  // NOTE(ed): leaving this check in place because old tests depend on
  // it and it therefore might happen in production.
  if (typeof tagId !== 'number') {
    return ['unknown']
  } else if (['title'].indexOf(type) !== -1) {
    return ['tag', tagId, type]
  } else {
    return ['unknown']
  }
}
